<template>
  <div id="nav">
    <div id="nav-btn">
      <router-link
        to="/"
        class="btns"
      >{{ $t("nav.home") }}</router-link>
      <router-link
        to="/character"
        class="btns"
      >{{ $t("nav.role") }}</router-link>
      <router-link
        to="/video"
        class="btns"
      >{{ $t("nav.video") }}</router-link>
      <router-link
        to="/announcement"
        class="btns"
      >{{ $t("nav.announcement") }}</router-link>
      <router-link
        to="/guide"
        class="btns"
      >{{ $t("nav.guide") }}</router-link>
    </div>
    <div id="nav-lang">
      <span
        class="lang-btns"
        :class="this.$i18n.locale == 'zh' ? 'lang-active' : ''"
        @click.stop="changeLang('zh')"
      >简体中文</span> |
      <span
        class="lang-btns"
        :class="this.$i18n.locale == 'en' ? 'lang-active' : ''"
        @click.stop="changeLang('en')"
      >English</span> |
      <span
        class="lang-btns"
        :class="this.$i18n.locale == 'ja' ? 'lang-active' : ''"
        @click.stop="changeLang('ja')"
      >日本語</span>
    </div>
    <div id="nav-icon">
      <a
        v-for="icon in icons[this.$i18n.locale]"
        :key="icon.alt"
        :href="icon.url"
        target="_blank"
      >
        <img
          :src="icon.icon"
          :alt="icon.alt"
          class="icon-btns"
        >
      </a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      icons: {
        "zh": [
          {
            "alt": "QQ",
            "icon": require("../assets/images/202510/icons/zh/qq.png"),
            "url": "https://pd.qq.com/s/al26pdtoh"
          },
          {
            "alt": "bilibili",
            "icon": require("../assets/images/202510/icons/zh/bilibili.png"),
            "url": "https://space.bilibili.com/1663803541"
          },
          {
            "alt": "小黑盒",
            "icon": require("../assets/images/202510/icons/zh/xiaoheihe.png"),
            "url": "https://www.xiaoheihe.cn/app/topic/game/pc/2273430"
          }
        ],
        "en": [
          {
            "alt": "Youtube",
            "icon": require("../assets/images/202510/icons/en/youtube.png"),
            "url": "https://www.youtube.com/@BBEE_Global"
          },
          {
            "alt": "X",
            "icon": require("../assets/images/202510/icons/en/x.png"),
            "url": "https://x.com/BBEE_Global"
          },
          {
            "alt": "Ins",
            "icon": require("../assets/images/202510/icons/en/instagram.png"),
            "url": "https://www.instagram.com/blazblueentropyeffect"
          },
          {
            "alt": "Bluesky",
            "icon": require("../assets/images/202510/icons/en/bluesky.png"),
            "url": "https://bsky.app/profile/bbee-global.bsky.social"
          }
        ],
        "ja": [
          {
            "alt": "Youtube",
            "icon": require("../assets/images/202510/icons/ja/youtube.png"),
            "url": "https://www.youtube.com/@BBEE_Global"
          },
          {
            "alt": "X",
            "icon": require("../assets/images/202510/icons/ja/x.png"),
            "url": "https://x.com/BBEE_JAPAN"
          },
          {
            "alt": "Ins",
            "icon": require("../assets/images/202510/icons/ja/instagram.png"),
            "url": "https://www.instagram.com/blazblueentropyeffect"
          },
          {
            "alt": "Bluesky",
            "icon": require("../assets/images/202510/icons/ja/bluesky.png"),
            "url": "https://bsky.app/profile/bbee-global.bsky.social"
          }
        ]
      }
    }
  },
  methods: {
    changeLang(lang) {
      this.$i18n.locale = lang
      document.title = this.$i18n.t('meta.base')
    },
  },
  beforeCreate() {
    document.title = this.$i18n.t('meta.base')
  }
}
</script>

<style scoped lang="scss">
#nav {
  width: 1920px;
  height: 97px;
  position: fixed;
  left: 0;
  top: 0;
  background-image: url("../assets/images/nav-back.png");
  background-size: 100%;
  background-repeat: no-repeat;
  z-index: 999;
  box-sizing: border-box;
}

#nav-btn {
  position: absolute;
  left: 300px;
  bottom: 0;
  text-align: center;
  // 注释避免字体大小转为rem
  font-size: 18px;
  /*no*/
  font-family: "MiSans-Bold";
  display: flex;
  align-items: center;
  height: 100%;
}

.btns {
  min-width: 170px;
  max-width: 200px;
  width: auto;
  height: 97px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 0 20px;
  text-decoration: none;
  color: #888888;
  white-space: normal;
  line-height: 1.4;
  padding: 0 10px;
  box-sizing: border-box;

  &:hover {
    background-image: url("../assets/images/btn-hover.png");
    background-size: contain;
    background-repeat: round;
    font-weight: 600;
    color: #fff;
  }

  &.router-link-exact-active {
    background-image: url("../assets/images/btn-active.png");
    background-size: contain;
    background-repeat: round;
    font-weight: 600;
    color: white;
  }
}

#nav-lang {
  width: 270px;
  position: absolute;
  right: 250px;
  top: 40px;
  text-align: center;
  color: #838383;
  font-size: 12px;
  /*no*/
  font-family: "MiSans-Bold";
}

.lang-btns {
  cursor: pointer;
  margin: 0 12px;
}

.lang-btns:last-child {
  margin-right: 0;
}

.lang-active {
  color: white;
}

#nav-icon {
  position: absolute;
  right: 30px;
  top: 30px;
}

.icon-btns {
  width: 34px;
  padding: 0 7px;
  cursor: pointer;
}
</style>
